<template>
<div class="page-box" style="padding: 0 15px; max-height: calc(100vh - 100px); overflow-y: auto;">
     
    <el-breadcrumb separator-class="el-icon-arrow-right" 
        style="margin-bottom: 25px; margin-top: 25px; margin-left: 15px;"
    >
        <el-breadcrumb-item>商品</el-breadcrumb-item>
        <el-breadcrumb-item>自动改天数</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="xm-alert" v-if="showAlert1">
        <div class="xm-alert-icon">
            <i class="el-icon-warning-outline"></i>
        </div>
        <div class="xm-alert-content">
            <div class="xm-alert-title">自动改天数功能现仅开放合作发货客户使用，未发货客户可联系客服咨询详情，或者也可以通过"自动上下架功能"实现一样的效果。</div>
        </div>
        <div class="xm-alert-close" @click="closeAlert1">
            <i class="el-icon-close"></i>
        </div>
    </div>
    <div class="xm-product-step">
        <div class="xm-step-title-wrap">
            <div class="xm-step-title">自动改天数流程</div>
        </div>
        <div class="xm-step-content">
            <div class="step-item">
                <div class="step-num ">1</div>
                <div class="step-item-content">
                    <div class="step-item-title-wrap">
                        <span class="step-item-title">同步商品</span>
                        <span class="step-line"></span>
                    </div>
                    <div class="step-item-desc">初次使用或较长时间未使用先同步最新商品信息</div>
                </div>
            </div>
            <div class="step-item">
                <div class="step-num ">2</div>
                <div class="step-item-content">
                    <div class="step-item-title-wrap">
                        <span class="step-item-title">锁定商品</span>
                        <span class="step-line"></span>
                    </div>
                    <div class="step-item-desc">不需要改动的店铺商品进行商品锁定则不会修改</div>
                </div>
            </div>
            <div class="step-item">
                <div class="step-num ">3</div>
                <div class="step-item-content">
                    <div class="step-item-title-wrap">
                        <span class="step-item-title">添加任务</span>
                    </div>
                    <div class="step-item-desc">添加自动修改任务,可以定时添加多条件修改任务</div>
                </div>
            </div>
        </div>
    </div>
    <div class="xm-alert" v-if="showAlert2">
        <div class="xm-alert-content"> 
            <div class="xm-alert-title" style="font-size:12px;">
                同步完成
                总计：<span style="color: rgba(0, 0, 0, 0.6)">51217</span>
                处理中：<span style="color: rgb(0, 82, 217);">0</span>
                成功：<span style="color: rgb(43, 164, 113);">2</span>
                失败：<span style="color: rgb(213, 73, 65);">2</span>
            </div>
            <div class="xm-alert-desc">
                <el-progress :percentage="percentage" style="width: 350px;" :color="customColor"></el-progress>
            </div>
           
        </div>
        <div class="xm-alert-close" @click="closeAlert2">
            <i class="el-icon-close"></i>
        </div>
    </div>
    <div class="xm-product-content">
        <div class="xm-product-query-wrap">
            <el-input type="text" name="kwd" size="small" placeholder="请输入店铺名" v-model="query.shopName" style="width: 420px;" />
            <div class="xm-product-query-buttons">
                <el-button type="primary" size="mini" icon="el-icon-search" color="#0052d9" radius="2px" @click="list(true)">
                    搜索
                </el-button>
                <el-button size="mini" icon="el-icon-paperclip"  radius="2px" @click="openSyncDialog">
                    同步商品
                </el-button>
                <el-button type="warning" size="mini" icon="el-icon-lock"  radius="2px" @click="openLockDialog">
                    锁定商品
                </el-button>
                <el-button type="danger" size="mini" icon="el-icon-folder-add" radius="2px" @click="openTaskDialog">
                    批量添加
                </el-button>
            </div>
        </div>
        <div class="table-box" id="xm-product-auto-day-table">
            <vxe-grid ref="dataTable" 
                resizable border
                export-config
                show-overflow highlight-hover-row
                highlight-current-row highlight-hover-column highlight-current-column
                :data="products"
                :columns="columns"
                @cell-click="checkRow"
            ></vxe-grid>
        </div>
        <pagenator
            @page-change="handlerPageChange"
            :query="query"
        >
        </pagenator>
    </div>

    <!-- 同步商品弹窗 -->
    <sync-product-dialog 
        :visible.sync="syncDialogVisible" 
        @confirm="handleSyncConfirm"
    />

    <!-- 添加任务弹窗 -->
    <add-task-dialog 
        :visible.sync="taskDialogVisible" 
        @confirm="handleTaskConfirm"
    />

    <!-- 锁定商品弹窗 -->
    <lock-product-dialog 
        :visible.sync="lockDialogVisible" 
    />

</div>

</template>

<script>
import Pagenator from "../../components/Pagination.vue";
import SyncProductDialog from "./SyncProductDialog.vue";
import AddTaskDialog from "./AddTaskDialog.vue";
import LockProductDialog from "./LockProductDialog.vue";

export default {
    name: "productAutoDay",
    components: {
        Pagenator: Pagenator,
        SyncProductDialog: SyncProductDialog,
        AddTaskDialog: AddTaskDialog,
        LockProductDialog: LockProductDialog
    },
    data() {
        return {
            query: {
                shopName: '',
                length: 20, //每页显示的长度
                start: 0, //起始数量
                pageTotal:0,//总记录数
                pageIndex: 1
            },
            products: [],
            columns: [],
            percentage: 20,
            customColor: '#2ba471',
            showAlert1: true,
            showAlert2: true,
            syncDialogVisible: false,
            taskDialogVisible: false,
            lockDialogVisible: false,
        }
    },
    mounted() {
        this.list();
        this.buildColumns();
    },
    computed: {
    },
    methods: {
        buildColumns(){
            this.columns = [
                {type: 'checkbox', minWidth: 50, width: 50, fixed: 'left'},
                {
                    field: 'name',title: '店铺名', width: 200, className:"shop-name-cell",
                    slots: {
                        default: ({ row }) => {
                            return [
                                <div>
                                    <div class="shop-name-text">{row.name} </div>
                                    <div class="shop-type-text" >
                                        <img src={require('@/assets/img/productType.png')} 
                                            style="height: 21px; margin-right: 5px;"/>
                                            <el-tag size="mini" type="primary" style="color: #0052d9;">TW</el-tag>
                                    </div>
                                    <div style="font-size: 12px; color: #999;">
                                       店铺ID：{row.shopId}
                                    </div>
                                </div>
                            ];
                        },
                    }

                 },
                {field: 'actualName',title: '店铺别名', width: 200, className:"shop-alias-cell" },
                {field: 'xianhuo',title: '现货商品' },
                {field: 'yushou',title: '预售商品' },
                {field: 'offShelfProduct',title: '已下架商品' },
                {field: 'nextDayProduct',title: '隔日到货商品' },
                {field: 'locked',title: '锁定商品' },
                {field: 'shopId',title: '时间', width: 200, className:"time-cell",
                    slots: {
                        default: ({ row }) => {
                            return [
                                <div class="time-text">
                                    <div class="time-text-item">
                                        <span class="time-text-item-label">最近执行：</span>{row.lastTime || '--'}
                                    </div>
                                    <div class="time-text-item">
                                        <span class="time-text-item-label">下次执行：</span>{row.nextTime || '--'}
                                    </div>
                                    <div class="time-text-item">
                                        <span class="time-text-item-label">最近同步：</span>{row.syncTime || '--'}
                                    </div> 
                                </div>
                            ];
                        },
                    }
                },
                {field: 'executionStatus',title: '执行情况',
                    slots: {
                        default: ({ row }) => {
                            return [
                                <div class="execution-status-text">
                                     <el-tag size="mini" type="primary">{this.getExecutionStatus(row.executeStatus)}</el-tag>
                                     {row.executePercentage > 0 && (
                                         <div class="execution-status-progress">
                                             <el-progress percentage={row.executePercentage} color={this.customColor}></el-progress>
                                         </div>
                                     )}
                                </div>
                            ];
                        },
                    }
                },
                {field: 'id', title: '操作', width: 100, className:"operation-cell",
                    slots: {
                        default: ({ row }) => {
                            return [
                                <div class="operation-text">
                                   <el-button type="text" style="display:block; margin-left: 10px;" size="mini" onClick={()=>this.openTaskDialog(row)}>添加任务</el-button>
                                   <el-button type="text" style="display:block;" size="mini">执行记录</el-button>
                                </div>
                            ];
                        },
                    }
                }
            ]
        },
        closeAlert1() {
            this.showAlert1 = false;
        },
        closeAlert2() {
            this.showAlert2 = false;
        },
        getExecutionStatus(status) {
            switch(status) {
                case 0:
                    return '未执行';
                case 1:
                    return '执行中';
                case 2:
                    return '执行成功';
                case 3:
                    return '执行失败';
                default:
                    return '--';
            }
        },
        checkRow({row, $event}){
            //如果点击checkbox 则不处理
            if($event.target.className.indexOf("vxe-checkbox--icon")== -1){
                var table =  this.$refs.dataTable;
                table.setCheckboxRow([row], !table.isCheckedByCheckboxRow(row))
            }
        },
        getList() {
            // 引入JSON文件中的mock数据
            import('./productAutoDayMockData.json').then(data => {
                this.products = data.default || data;
            }).catch(error => {
                console.error('Failed to load mock data:', error);
                this.products = [];
            });
        },
        list(refresh){

            if(refresh){
                this.query.pageIndex = 1;
                this.query.start = 0;
            }

            var param = this.$kit.rebuildQuery(this.query);
            
            this.$axios.post(this.$kit.api.shopProduct.autoDayList, param)
                .then((result) => {
                    if(result.status){
                        this.products = result.data.list;
                        this.query.pageTotal = result.data.total;
                    }else{
                        this.$message(result.msg || this.msg('获取失败'));
                    }
                });
        },
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            this.list();
        },
        openSyncDialog() {
            this.syncDialogVisible = true;
        },
        openTaskDialog() {
            this.taskDialogVisible = true;
        },
        handleSyncConfirm(params) {
            console.log('同步商品参数:', params);
            // 这里可以调用同步商品的API
            this.$message.success('同步商品任务已提交');
        },
        handleTaskConfirm(params) {
            console.log('添加任务参数:', params);
            // 这里添加任务或者执行任务
            this.$message.success('任务已提交');
        },
        openLockDialog() {
            this.lockDialogVisible = true;
        },
    }
}
</script>


<style scoped>
#xm-product-auto-day-table /deep/ .shop-name-cell {
    height: auto; 
    padding: 10px 3px;
}
#xm-product-auto-day-table /deep/ .shop-name-cell > div{
    max-height: inherit;
}
#xm-product-auto-day-table /deep/ .shop-name-text {
    font-size: 14px; 
    word-wrap: break-word;
    text-wrap: auto; 
    white-space: break-spaces;
    line-height: 1.4;
    margin-bottom: 5px;
}
#xm-product-auto-day-table /deep/ .shop-type-text {
    display: flex; 
    align-items: center;
}
#xm-product-auto-day-table /deep/ .vxe-body--row .vxe-body--column:not(.col--checkbox) {
    padding: 10px 3px;
    vertical-align: top;
}
#xm-product-auto-day-table /deep/ .shop-alias-cell > div {
    text-wrap: auto;
}

#xm-product-auto-day-table /deep/ .vxe-body--column {
    color: black !important;
}

#xm-product-auto-day-table /deep/ .time-cell {
    height: auto; 
    padding: 10px 3px;
    font-size: 12px; 
}
#xm-product-auto-day-table /deep/ .time-cell > div{
    max-height: inherit;
    color: rgba(0, 0, 0, 0.9);
}

#xm-product-auto-day-table /deep/ .time-text-item-label {
    color: rgba(0, 0, 0, 0.6);
    margin-right: 5px;
}

/* Alert样式 */
.xm-alert {
    width: 100%;
    padding: 16px 20px;
    border-radius: 6px;
    background: rgb(255, 217, 194);
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    box-sizing: border-box;
}

.xm-alert-icon {
    margin-right: 24px;
    margin-top: 2px;
    flex-shrink: 0;
}

.xm-alert-icon i {
    color: rgb(227, 115, 24);
    font-size: 24px;
}

.xm-alert-content {
    flex: 1;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 1.5;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.xm-alert-title {
    font-weight: 500;
    white-space: nowrap;
    flex-shrink: 0;
}

.xm-alert-desc {
    flex-shrink: 0;
}

.xm-alert-close {
    margin-left: 12px;
    margin-top: 2px;
    flex-shrink: 0;
    cursor: pointer;
}

.xm-alert-close i {
    color: rgba(0, 0, 0, 0.6);
    font-size: 16px;
}

.xm-alert-close:hover i {
    color: rgba(0, 0, 0, 0.8);
}

/* Product Step样式 - 参考OrderStep.vue */
.xm-product-step {
    padding: 30px 20px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.04);
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.xm-step-title-wrap {
    display: flex;
    align-items: center;
    height: 100%;
    margin-right: 40px;
    flex-shrink: 0;
}

.xm-step-title {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 12px 20px;
    color: white;
    font-weight: bold;
    font-size: 14px;
    position: relative;
    min-width: 0;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    line-height: 1;
    background: #597ef7;
    border-radius: 4px;
}

.xm-step-title::after {
    content: '';
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 20px solid #597ef7;
    border-top: 19px solid transparent;
    border-bottom: 19px solid transparent;
}

.xm-step-content {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 60px;
    flex: 1;
    height: auto;
}

.step-item {
    display: flex;
    align-items: flex-start;
    position: relative;
    flex: 1;
}

.step-item-title-wrap {
    display: flex;
    align-items: center;
}

.step-item-title {
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    color: #333;
}

.step-line {
    display: inline-block;
    height: 0;
    border-top: 1px dashed #597ef7;
    margin-left: 8px;
    flex: 1;
    position: relative;
    left: 45px;
}

.step-num {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 14px;
    margin-right: 15px;
    flex-shrink: 0;
    z-index: 1;
    background: #597ef7;
}

.step-item-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.step-item-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
}
.xm-product-content {
    background: #fff;
    border-radius: 6px;
}
/* 查询区域样式 */
.xm-product-query-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.04);
}

.xm-product-query-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* 分页器固定在页面底部 */
.table-box {
    position: relative;
}

/* xm-product-content 容器设置 */
.xm-product-content {
    position: relative;
}

/* 分页器固定在 xm-product-content 容器底部 */
#xpagination {
    position: sticky !important;
    bottom: 0 !important;
    background: white !important;
    z-index: 10 !important;
    border-top: 1px solid #e8e8e8 !important;
    padding: 15px 20px !important;
    box-shadow: 0 -2px 8px rgba(0,0,0,0.1) !important;
    margin: 0 !important;
    width: 100% !important;
    box-sizing: border-box !important;
}

/* 表格样式设置 */
#xm-product-auto-day-table /deep/ .vxe-table {
    height: auto !important;
}

/* 表头固定样式 */
#xm-product-auto-day-table /deep/ .vxe-table--header-wrapper {
    position: sticky;
    top: 0;
    z-index: 100;
    background: white;
}

/* 确保表格不产生自己的滚动条 */
#xm-product-auto-day-table /deep/ .vxe-table--main-wrapper {
    overflow: visible !important;
}

#xm-product-auto-day-table /deep/ .vxe-table--body-wrapper {
    overflow: visible !important;
}

</style>